import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {NyEventComponent} from "./ny-event.component";

const routes: Routes = [
  {
    path: '',
    component: NyEventComponent,
    pathMatch: 'full',
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NyEventRoutingModule {}
